// extracted by css-extract-rspack-plugin
export default {"SectionCard":"mKVJJ"};